<template lang="pug">
  .main
    Hero(:content="heroContent")
    .container.rows.wrapRWD
      .col
        h3 台灣
        p 社團法人德普文教協會<br>TEP Culture and Education Association (TEP)<br>聯絡地址 : 台灣新北市永和區中和路447號5樓<br>統一編號 : 31841865
        p 理事長<br>侯禮仁 Peter Hou<br>+886(0)980824005<br>LINE ID : peterhou123<br>WeChat ID : houlizen<br>houlizen@gmail.com
        p 秘書長<br>劉玉婷 Jade Liu<br>+886(0)975970261<br>LINE ID : jadeliuyuting<br>WeChat ID : Jadeliuyuting<br>TaiwanGo@outlook.com
      .col
        h3 柬埔寨
        p 柬埔寨台灣教育及就業計畫<br>Cambodia-Taiwan Education and Employment Program (CTEP)<br>Address : Lok Taneuy Road, Sangkat Sala Kamreuk,Krong Siem Reap, Cambodia  (Opposite to New Star KTV)
        p 主任 Director<br>曾本茹 Alice Tseng (Taiwan)<br>+855(0)68874823<br>+855(0)83333318 <br>benrutzeng@gmail.com
        p Senior Manager<br>Chhun Soksan (Cambodia)<br>+855(0)98874823<br>chhun.soksan@gmail.com

</template>

<script>
import Hero from '@/components/Hero'

export default {
  components: {
    Hero
  },
  data () {
    return {
      heroContent: {
        title: '聯絡我們。',
        imageNo: 2
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Contact.vue